var _g, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_524_2321)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 85.5,
    r: 59.5,
    fill: "#DFDFDF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146 86C146 119.137 119.137 146 86 146C52.8629 146 26 119.137 26 86C26 52.8629 52.8629 26 86 26C119.137 26 146 52.8629 146 86Z",
    fill: "url(#paint0_linear_524_2321)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 140C115.823 140 140 115.823 140 86C140 56.1766 115.823 32 86 32C56.1766 32 32 56.1766 32 86C32 115.823 56.1766 140 86 140ZM86 146C119.137 146 146 119.137 146 86C146 52.8629 119.137 26 86 26C52.8629 26 26 52.8629 26 86C26 119.137 52.8629 146 86 146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.949 83.4724L101.218 98.3295H70.7819L65.0513 83.4724C64.8532 83.5032 64.6471 83.5341 64.441 83.5341C62.3406 83.5341 60.6365 81.8773 60.6365 79.8352C60.6365 77.7931 62.3485 76.1363 64.4489 76.1363C66.5493 76.1363 68.2535 77.7931 68.2535 79.8352C68.2535 80.3823 68.1188 80.8986 67.9048 81.361L73.6353 84.7054C74.848 85.4144 76.4332 85.0136 77.1387 83.8115L83.5985 72.8228C82.7504 72.1447 82.1956 71.1275 82.1956 69.9716C82.1956 67.9295 83.8997 66.2727 86.0001 66.2727C88.1005 66.2727 89.8047 67.9295 89.8047 69.9716C89.8047 71.1275 89.2498 72.1447 88.4017 72.8228L94.8615 83.8115C95.567 85.0136 97.1442 85.4144 98.3649 84.7054L104.103 81.361C103.881 80.8909 103.755 80.3823 103.755 79.8352C103.755 77.7931 105.459 76.1363 107.559 76.1363C109.66 76.1363 111.364 77.7931 111.364 79.8352C111.364 81.8773 109.66 83.5341 107.559 83.5341C107.353 83.5341 107.147 83.5032 106.949 83.4724ZM103.755 104.494C103.755 105.172 103.184 105.727 102.486 105.727H69.5137C68.8163 105.727 68.2456 105.172 68.2456 104.494V102.028C68.2456 101.35 68.8163 100.795 69.5137 100.795H102.486C103.184 100.795 103.755 101.35 103.755 102.028V104.494Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_524_2321",
    x: 6,
    y: 6,
    width: 159,
    height: 159,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_524_2321"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_2321",
    x1: 53.5,
    y1: 34.5,
    x2: 123,
    y2: 130.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39200"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/Premium.1010eb70cea1138749f565fc84f91408.svg";
export { ForwardRef as ReactComponent };